module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture15-8fe129d5408992610ac98bbf325bcfc8.jpg";